import { render, staticRenderFns } from "./RUploadCompleteAlertCard.vue?vue&type=template&id=4b21ed4e&scoped=true&"
import script from "./RUploadCompleteAlertCard.vue?vue&type=script&lang=js&"
export * from "./RUploadCompleteAlertCard.vue?vue&type=script&lang=js&"
import style0 from "./RUploadCompleteAlertCard.vue?vue&type=style&index=0&id=4b21ed4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b21ed4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VDivider,VIcon,VProgressLinear})
